export default __webpack_public_path__ + "static/data-fund-6a7dc0edd26cd8a079102ee9ffead8d6.png";